import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imagejob',
  templateUrl: './imagejob.component.html',
  styleUrls: ['./imagejob.component.css']
})
export class ImagejobComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }


  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


  requestData = `
  curl -X POST https://api.optimusdrive.ai/image/v1/batch \
  -H "Content-Type: application/json" \
-H 'authorization: XXX' \
-d '{
  "urls": [
   "https://cdn.pixabay.com/photo/2022/09/11/14/52/bee-7446944_960_720.jpg",
   "https://cdn.pixabay.com/photo/2012/06/19/10/32/owl-50267_960_720.jpg"
  ],
  "crunch_mode": "upscaler_4x",
  "callback_params": {
   "callback_url": "https://webhook.site/de315b33-c529-4adb-8945-5f36c5377346",
   "custom_data": {
     "store_id": 12345,
     "store_name": "Sample Store"
   }
  }
  }'

  `

  sucessData = `
  {
    "data": {
      "id": "e9fce0a7-4999-4843-893d-9539219b3a74",
      "status": "PENDING",
      "callback_params": {
        "callback_url": "https://webhook.site/de315b33-c529-4adb-8945-5f36c5377346",
        "custom_data": {
          "store_id": 12345,
          "store_name": "Sample Store"
        }
      },
      "created_at": 1690533723,
      "crunch_mode": "upscaler_4x",
      "updated_at": 1690533723,
      "source": "url",
      "urls": [
        {
          "input_url": "https://cdn.pixabay.com/photo/2022/09/11/14/52/bee-7446944_960_720.jpg",
          "output_url": "",
          "filename": "",
          "original_size": 0,
          "output_size": 0,
          "input_width": 0,
          "input_height": 0,
          "output_width": 0,
          "output_height": 0,
          "status": "PENDING",
          "thumbnail": ""
        },
        {
          "input_url": "https://cdn.pixabay.com/photo/2012/06/19/10/32/owl-50267_960_720.jpg",
          "output_url": "",
          "filename": "",
          "original_size": 0,
          "output_size": 0,
          "input_width": 0,
          "input_height": 0,
          "output_width": 0,
          "output_height": 0,
          "status": "PENDING",
          "thumbnail": ""
        }
      ]
    },
    "message": "Batch created successfully"
  }`
  

  Error401x = `
  {
    "message":"Unauthorized"
  }`


}
